import {
  PageMeta,
  airbusHelicopterCustomerCaseMeta,
  airbusUpNextCustomerCaseMeta,
  hondaMarineCustomerCaseMeta,
  brunswickUseCaseCustomerCaseMeta,
  portOperationsCustomerCaseMeta,
} from 'constants/pages';
import { ICustomerCaseData } from 'types/customer-case';
import { firstCustomerCaseData } from './first-customer-case';
import { secondCustomerCaseData } from './second-customer-case';
import { thirdCustomerCaseData } from './third-customer-case';
import { forthCustomerCaseData } from './forth-customer-cases';
import { fifthCustomerCaseData } from './fifth-customer-case';
import { isDemo, isDev } from 'constants/env';

export interface ICustomerCaseItem {
  pageMeta: PageMeta;
  data: ICustomerCaseData;
}

export const CUSTOMER_CASES: ICustomerCaseItem[] = [
  {
    pageMeta: airbusHelicopterCustomerCaseMeta,
    data: firstCustomerCaseData,
  },
  {
    pageMeta: brunswickUseCaseCustomerCaseMeta,
    data: thirdCustomerCaseData,
  },
  {
    pageMeta: airbusUpNextCustomerCaseMeta,
    data: forthCustomerCaseData,
  },
  {
    pageMeta: portOperationsCustomerCaseMeta,
    data: fifthCustomerCaseData,
  },
  // Show Honda Marine case only in demo/dev environments
  ...(isDemo || isDev
    ? [
        {
          pageMeta: hondaMarineCustomerCaseMeta,
          data: secondCustomerCaseData,
        },
      ]
    : []),
];
